import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import UsersList from "./UsersList";
import UserCreate from "./UserCreate";
import UserEdit from "./UserEdit";
import UserReset from "./UserReset";
import { RoleEnum } from "../../types/RoleEnum";
import { RouteGuard } from "../../guards/RouteGuard";
function Users() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return React.createElement(UsersList, null); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER, RoleEnum.PUBLISHER_ADMIN, RoleEnum.ADMIN_LEGAL_DEPOSITS] },
                React.createElement(UserCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER, RoleEnum.PUBLISHER_ADMIN, RoleEnum.ADMIN_LEGAL_DEPOSITS] },
                React.createElement(UserEdit, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/reset/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER, RoleEnum.PUBLISHER_ADMIN, RoleEnum.ADMIN_LEGAL_DEPOSITS] },
                React.createElement(UserReset, null))); } })));
}
export default Users;
